export const SET_SYSTEM_REDIRECT_BACK_LINK = 'SET_SYSTEM_REDIRECT_BACK_LINK'
export const SET_SYSTEM_REDIRECT_FORWARD_LINK = 'SET_SYSTEM_REDIRECT_FORWARD_LINK'
export const SET_SYSTEM_REDIRECT_CLEAR = 'SET_SYSTEM_REDIRECT_CLEAR'
export const SET_SYSTEM_REDIRECT_LINKS = 'SET_SYSTEM_REDIRECT_LINKS'

function setBackLink(state, backLink) {
    return {
        ...state,
        backLink: backLink,
    }
}

function setForwardLink(state, forwardLink) {
    return {
        ...state,
        forwardLink,
    }
}

function clearLinks(state) {
    return {
        ...state,
        backLink: null,
        forwardLink: null,
    }
}

function setLinks(state, backLink, forwardLink, isLoginRedirect) {
    return {
        ...state,
        backLink: backLink,
        forwardLink: forwardLink,
        isLoginRedirect: isLoginRedirect,
    }
}

/**
 * Reducer for on boarding
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_SYSTEM_REDIRECT_BACK_LINK: return setBackLink(state, action.backLink)
        case SET_SYSTEM_REDIRECT_FORWARD_LINK: return setForwardLink(state, action.forwardLink)
        case SET_SYSTEM_REDIRECT_CLEAR: return clearLinks(state)
        case SET_SYSTEM_REDIRECT_LINKS: return setLinks(state, action.backLink, action.forwardLink, action.isLoginRedirect)
        default: return state
    }
}
